import store from './../store'

export default {
  path: '/home',
  name: 'home',
  redirect: { name: 'home' },
  component: () => import('@/views/home/index.vue'),
  children: [
    {
      path: '/home',
      name: 'home.welcome-page',
      component: () => {
        return store.state.auth.user.user_type === 'tradie'
          ? import('@/views/home/WelcomePage.vue')
          : import('@/views/home/WelcomePageBAdmin.vue')
      },
    },
  ],
  beforeEnter: async (to, from, next) => {
    if (store.state.auth.user) {
      next()
    } else {
      store
        .dispatch('auth/getAuthenticatedUser')
        .catch(() => next({ name: 'auth.login-page' }))
        .finally(() => next())
    }
  },
}
